import { useCallback, useEffect, useState } from "react";
import {
  listVisibleOfflineOperations,
  OFFLINE_QUEUE_EVENT,
  removeOfflineOperation,
  retryOfflineOperation,
  syncOfflineOperations,
} from "../../Utills/offlineQueue";
import "./style.css";

const OfflineSyncStatus = () => {
  const [online, setOnline] = useState(navigator.onLine);
  const [operations, setOperations] = useState([]);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    try { setOperations(await listVisibleOfflineOperations()); }
    catch { setOperations([]); }
  }, []);

  useEffect(() => {
    const onOnline = () => { setOnline(true); syncOfflineOperations(); };
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    window.addEventListener(OFFLINE_QUEUE_EVENT, refresh);
    refresh();
    const timer = window.setInterval(() => { if (navigator.onLine) syncOfflineOperations(); }, 15000);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      window.removeEventListener(OFFLINE_QUEUE_EVENT, refresh);
      window.clearInterval(timer);
    };
  }, [refresh]);

  if (online && operations.length === 0) return null;
  const failed = operations.filter(item => item.status === "failed").length;
  const syncing = operations.some(item => item.status === "syncing");
  const label = !online ? `Offline${operations.length ? ` · ${operations.length} queued` : ""}`
    : failed ? `${failed} order${failed === 1 ? "" : "s"} need attention`
      : syncing ? "Syncing orders…" : `${operations.length} order${operations.length === 1 ? "" : "s"} queued`;

  return (
    <div className="offline-sync">
      <button className={`offline-sync__badge ${online ? "is-online" : "is-offline"}`} type="button" onClick={() => setOpen(value => !value)}>
        <span aria-hidden="true">{online ? "↻" : "●"}</span> {label}
      </button>
      {open && (
        <section className="offline-sync__panel" aria-label="Offline order queue">
          <header><strong>Order sync</strong><button type="button" onClick={() => setOpen(false)} aria-label="Close">×</button></header>
          {!operations.length && <p>Your connection is offline. Order submission will be saved on this device.</p>}
          {operations.map(operation => (
            <article key={operation.id}>
              <div><strong>{operation.label}</strong><span>{operation.status} · {new Date(operation.createdAt).toLocaleString()}</span></div>
              {operation.lastError && <p>{operation.lastError}</p>}
              <div className="offline-sync__actions">
                {operation.status === "failed" && <button type="button" onClick={() => retryOfflineOperation(operation.id)}>Retry</button>}
                <button type="button" onClick={() => removeOfflineOperation(operation.id)}>Remove</button>
              </div>
            </article>
          ))}
          {online && operations.some(item => item.status !== "failed") && <button className="offline-sync__sync" type="button" onClick={syncOfflineOperations}>Sync now</button>}
        </section>
      )}
    </div>
  );
};

export default OfflineSyncStatus;
